import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [FormsModule, RouterModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  email: string = '';

  onSubmit() {
    if (this.email) {
      console.log('Subscribed with email:', this.email);
      // In a real implementation, this would call a service to submit the email
      alert('Thank you for subscribing!');
      this.email = '';
    }
  }

  downloadBrochure(): void {
    const filePath = 'assets/images/Herbs_LFY_Brochure.pdf';
    const a = document.createElement('a');
    a.href = filePath;
    a.download = 'brochure.pdf';
    a.click();
  }
}
